import type { Chip } from "$components/chip";
import React from "react";

type StatusChipProps = React.ComponentProps<typeof Chip>;

export const chipColors: Record<
  "positive" | "negative" | "neutral",
  StatusChipProps["color"]
> = {
  positive: "brand",
  negative: "pink",
  neutral: "disabled",
};
